import React from "react";
import { checkIsArrayEmpty } from "features/Common/modules/DataTypes/utils/Array.utils";
import { checkIsStringEmpty } from "features/Common/modules/DataTypes/Strings.utils";

export const OfferingNameChips = ({
  listingNames,
  className = "",
  parentClassName = "",
}: {
  listingNames: string[];
  className?: string;
  parentClassName?: string;
}) => {
  if (checkIsArrayEmpty(listingNames)) return <>-</>;

  return (
    <div
      className={`tw-flex tw-flex-wrap tw-gap-2 tw-py-[10px] ${parentClassName}`}
    >
      {listingNames.map((listingName, index) => {
        if (checkIsStringEmpty(listingName)) return "N/A";
        return (
          <div
            key={`${listingName}-${index}`} /* eslint-disable-line react/no-array-index-key */
            className={`tw-border-solid tw-border-[1px] tw-border-[#493ab1] tw-bg-[#eeecf9] tw-text-[#493ab1] tw-text-sm tw-font-normal tw-leading-[22px] tw-rounded tw-px-2 tw-w-fit ${className}`}
          >
            {listingName}
          </div>
        );
      })}
    </div>
  );
};
